import Vue from "vue";
import Vuex from "vuex";
import cn from './lib/cn.js'
import en from './lib/en.js'
// import {
//   threadId
// } from "worker_threads";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lanType: '',
    footerType: '1',
    showLoading: false,
    //消息提示框
		msgModal: {
			showMsgModal: false,
			setModal: {
				autoClose: true,
				info:''
      },
    },
    actionModal: {
      showActionModal: false,
      info:''
    },
  },
  mutations: {
    setLanType(state, lan) {
      localStorage.lanType = lan;
      if (lan == 'en') {
        state.lanType = 'en'
      } else {
        state.lanType = 'cn'
      }
    },
    changeFooter(state, lan) {
      state.footerType = lan;
    },
    showActionModal (state, setting) {
      state.actionModal = setting;
    },
    showMsgModal (state, status) {
      state.msgModal.showMsgModal = status;
    },
    setMsgModal (state, setModal){
      state.msgModal.setModal = setModal;
    },
    showLoading(state, status){
      state.showLoading = status;
    },
   
  },
  getters: {
    getLanInfo(state) {
      if (state.lanType) {
        if (state.lanType == 'en') {
          return en;
        } else {
          return cn;
        }
      } else if (localStorage.lanType) {
        state.lanType = localStorage.lanType;
        if (state.lanType == 'en') {
          return en;
        } else {
          return cn;
        }
      } else {
        return cn
      }
    },
    getLanType(state) {
      if (state.lanType) {
        return state.lanType;
      } else if (localStorage.lanType) {
        state.lanType = localStorage.lanType;
        return localStorage.lanType;
      } else {
        return 'cn'
      }
    }
  },
  actions: {
    showMsgModal({
      commit
    }, settings) {
      commit('setMsgModal', settings);
      commit('showMsgModal', true);
      if (settings.autoClose) {
        setTimeout(function () {
          commit('showMsgModal', false);
        }, 5000)
      }
    },
  }
});